import { Logo } from "./Logo";
import { TG_URL } from "@/lib/site";

const links = [
    ["Tokenomics", "#tokenomics"],
    ["Roadmap", "#roadmap"],
    ["How to Buy", "#how-to-buy"],
];

export const Navbar = () => (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-orange-500/15 bg-[#0D0B14]/80 backdrop-blur-xl">
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5" data-testid="navbar">
            <a href="#top" className="flex items-center gap-2.5" data-testid="nav-home-link">
                <Logo size={34} />
                <span className="font-heading text-sm font-800 tracking-widest text-orange-400" style={{ fontWeight: 800 }}>
                    $POWEEN
                </span>
            </a>
            <div className="hidden items-center gap-7 md:flex">
                {links.map(([label, href]) => (
                    <a
                        key={href}
                        href={href}
                        data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                        className="font-mono2 text-xs uppercase tracking-widest text-slate-400 transition-colors duration-300 hover:text-orange-400"
                    >
                        {label}
                    </a>
                ))}
            </div>
            <a
                href={TG_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-join-pack-btn"
                className="rounded-full bg-orange-500 px-5 py-2 font-mono2 text-xs font-bold uppercase tracking-wider text-[#0D0B14] transition-[box-shadow,transform] duration-300 hover:shadow-[0_0_25px_rgba(255,107,0,0.6)] hover:-translate-y-0.5"
            >
                Join Pack
            </a>
        </nav>
    </header>
);
